<div *ngIf="!loginServices.session()?.perfil" class="p-text-center">
    <p>Cargando perfil...</p>
</div>
<p-card *ngIf="loginServices.session()?.perfil">
    <div class="p-3">
<!--        <p-messages severity="error" *ngIf="!this.tramitePagosService.hasBalance()">-->
<!--            <ng-template pTemplate>-->
<!--                <div class="ml-2  text-xl">Estimado usuario, no posee saldo en su Cuenta Individual</div>-->
<!--            </ng-template>-->
<!--        </p-messages>-->
        <div class="border-round">
            <div class="text-center">
                <img [src]="imagenDemo" class="w-12rem h-12rem mr-3 flex-shrink-0 mb-3" style="border-radius:20%;"/>
                <div class="flex justify-content-center align-items-center gap-2">
                    <!-- Boton De Actualizar Foto -->
                    <!-- <p-fileUpload mode="basic" name="demo[]"
                                  accept="image/*" [maxFileSize]="this.fileUtilsService.maxFileSize" (onUpload)="actualizarFoto($event)" [auto]="true"
                                  chooseLabel="Actualizar foto"
                                  invalidFileSizeMessageSummary="Archivo demasiado grande"
                                  invalidFileSizeMessageDetail="El archivo supera el tamaño máximo permitido de {{ this.fileUtilsService.maxFileSize / 250000000 }} MB"></p-fileUpload> -->
                                  <!-- Implementar boton -->
                            <button pButton pRipple icon="pi pi-pencil" [label]="'Editar Perfil'"
                                class="p-button-rounded p-button-warning mr-2"
                                pTooltip="Editar" (click)="editarUsuario(usuarioSeleccionado!)"
                                [rounded]="true" [outlined]="true"></button>
                </div>
            </div>
            <ng-container *ngIf="mostrarUsuarioDialog()">
                <app-editar-perfil 
                    [usuarioDialog]="mostrarUsuarioDialog()"
                    (onClose)="mostrarUsuarioDialog.set(false)"
                    [idTipoPersona]="idTipoPersona"
                    (closeAndSaveDialogUser)="cerrarUsuarioDialog()"
                    (onSave)="guardarCambiosPerfil($event)" 
                    [editarPerfil]="true" 
                    [persona]="usuarioSeleccionado"
                ></app-editar-perfil>
            </ng-container>
            <div class="p-3">
                <div class="p-col-12 p-md-8">
                    <h2 class="p-text-center">{{ loginServices.session()?.perfil?.nombreCompleto }}</h2>
                    <div class="p-grid">
                        <div class="p-col-12 p-md-6">
                            <div class="p-field">
                                <label for="usuario"><strong>Usuario:</strong></label>
                                <p id="usuario">{{ loginServices.session()?.perfil?.usuario }}</p>
                            </div>
                            <div class="p-field">
                                <label for="tipoUsuario"><strong>Tipo de Usuario:</strong></label>
                                <p id="tipoUsuario">{{ loginServices.session()?.perfil?.tipoUsuario }}</p>
                            </div>
                            <div class="p-field">
                                <label for="verificada"><strong>Verificada:</strong></label>
                                <p id="verificada">{{ loginServices.session()?.perfil?.verificada ? 'Sí' : 'No' }}</p>
                            </div>
                        </div>
                        <div class="p-col-12 p-md-6">
                            <div class="p-field">
                                <label for="documento"><strong>Documento:</strong></label>
                                <p id="documento">{{ loginServices.session()?.perfil?.documento }}</p>
                            </div>
                            <div *ngIf="loginServices.session()?.perfil?.correo" class="p-field">
                                <label for="correo"><strong>Correo:</strong></label>
                                <p id="correo">{{ loginServices.session()?.perfil?.correo }}</p>
                            </div>
                        </div>
                        <div class="p-col-12 p-md-6">
                            <div class="p-field">
                                <label for="cta"><strong>Saldo cuenta:</strong></label>
                                <p id="cta">
                                    <span class="font-semibold">${{ (this.tramitePagosService.cuenta()?.saldo | number:'1.2-2') }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="p-col-12">
<!--                            <div class="p-field">-->
<!--                                <h3>Roles</h3>-->
<!--                                <ul>-->
<!--                                    <li *ngFor="let rol of loginServices.session()?.perfil?.roles">-->
<!--                                        {{ rol.rol }}-->
<!--                                    </li>-->
<!--                                </ul>-->
<!--                            </div>-->
                        </div>
                        <!-- InputSwitch para activar notificaciones de usuario -->
                        <!-- <div class="p-col-12 p-md-6">
                            <div class="p-field flex align-items-center gap-3">
                                <label for="" class="font-semibold">{{estadoNotificacion ? 'Desactivar notificaciones vía correo' : 'Activar notificaciones vía correo'}}</label>
                                <p-inputSwitch [(ngModel)]="estadoNotificacion" (onChange)="cambiarEstadoNotificacion()" 
                                    pTooltip="{{estadoNotificacion ? 'Desactiva notificaciones para solicitudes con requisitos pendientes, pagos pendientes o sin trámites asociados.' 
                                    : 'Activa notificaciones para solicitudes con requisitos pendientes, pagos pendientes o sin trámites asociados.'}}"
                                />
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-card>
<p-dialog *ngIf="loginServices.session()?.perfil"
          [modal]="true" [draggable]="false" [resizable]="false" #editarFotoDialog header="Editar foto de perfil"
          [(visible)]="showEditarFoto" [style]="{width: '50vw'}">
    <p-fileUpload uploadLabel="Actualizar foto de perfil" cancelLabel="Cancelar" mode="advanced" cancelIcon="true"
                  name="avatar" accept="image/*" [showCancelButton]="true" [maxFileSize]="this.fileUtilsService.maxFileSize"
                  styleClass="p-button-outlined p-button-plain mb-3" chooseLabel="Cambiar foto de perfil"
                  (onBeforeUpload)="convertirImagen($event)" (onSelect)="guardarImagen($event)"
                  invalidFileSizeMessageSummary="Archivo demasiado grande"
                  invalidFileSizeMessageDetail="El archivo supera el tamaño máximo permitido de {{ this.fileUtilsService.maxFileSize / 250000000 }} MB"></p-fileUpload>
    <p-fileUpload uploadLabel="Actualizar foto de perfil" cancelLabel="Cancelar" mode="basic" cancelIcon="true"
                  name="avatar" accept="image/*" [showCancelButton]="true" [maxFileSize]="this.fileUtilsService.maxFileSize"
                  styleClass="p-button-outlined p-button-plain mb-3" chooseLabel="Cambiar foto de perfil"
                  (onUpload)="convertirImagen($event)" (onSelect)="guardarImagen($event)"
                  invalidFileSizeMessageSummary="Archivo demasiado grande"
                  invalidFileSizeMessageDetail="El archivo supera el tamaño máximo permitido de {{ this.fileUtilsService.maxFileSize / 250000000 }} MB"></p-fileUpload>
    <p-fileUpload mode="basic" name="demo[]" accept="image/*"
                  [maxFileSize]="this.fileUtilsService.maxFileSize" (onUpload)="actualizarFoto($event)" [auto]="true"
                  chooseLabel="Elegir foto"
                  invalidFileSizeMessageSummary="Archivo demasiado grande"
                  invalidFileSizeMessageDetail="El archivo supera el tamaño máximo permitido de {{ this.fileUtilsService.maxFileSize / 250000000 }} MB"></p-fileUpload>
    <ng-template pTemplate="footer">
        <button type="button" (click)="showEditarFoto = !showEditarFoto" pButton icon="pi pi-times"
                label="Cancelar"></button>
    </ng-template>
</p-dialog>
<div
    *ngIf="isLoading()"
    style=" position: fixed; top: 0; left: 0; width: 100%;height: 100%; background-color: rgba(0, 0, 0, 0.4);display: flex; align-items: center; justify-content: center; z-index: 9999;">
    <p-progressSpinner
        styleClass="w-4rem h-4rem"
        strokeWidth="4"
        animationDuration=".5s"/>
</div>